import React, { Component } from 'react'
import PropTypes from 'prop-types'
import * as R from 'ramda'
import { connect } from 'react-redux'
import { compose } from 'recompose'
import injectSagas from 'helpers/injectSagas'
import CSSModules from 'helpers/CSSModulesUtil'
import Dialog from 'react-toolbox/lib/dialog'
import T from 'i18n-react'

import Input from './Input'
import FormTitle from 'components/fulcrum/formTitle/FormTitle'

import {
  MODULE_NAME,
} from './constants'

import {
  setInactiveDialog,
} from 'containers/Admin/Client/Client/actions'

import {
  resetForm,
  updateUsername,
  updateName,
  updateEmail,
  postClient,
} from './actions'

import {
  activeDialogSelector
} from 'containers/Admin/Client/Client/selectors'

import {
  usernameSelector,
  emailSelector,
  nameSelector,
} from './selectors'

import sagas from './sagas'

const mapStateToProps = (state) => {
  return {
    name: nameSelector(state),
    username: usernameSelector(state),
    email: emailSelector(state),
    active: activeDialogSelector(state)
  }
}

const mapDispatchToProps = (dispatch) => {
  return {
    toggleInactiveDialog: () => dispatch(setInactiveDialog()),
    onUsernameChange: (username) => dispatch(updateUsername(username)),
    onNameChange: (name) => dispatch(updateName(name)),
    onEmailChange: (email) => dispatch(updateEmail(email)),
    onSave: () => dispatch(postClient()),
  }
}

class ClientDialog extends Component {
  onCancel = () => this.props.toggleInactiveDialog()
  onSave = () => {
    this.props.onSave()
    this.props.toggleInactiveDialog()
  }

  actions = [
    { label: 'Save', onClick: this.onSave },
    { label: 'Cancel', onClick: this.onCancel },
  ]

  render() {
    const {
      name,
      username,
      email,
      active,
      toggleInactiveDialog,
      onUsernameChange,
      onNameChange,
      onEmailChange,
    } = this.props

    return (
      <Dialog
        actions={this.actions}
        active={active}
        title={T.translate('containers.admin.clientDialog.index.title')}
        onOverlayClick={toggleInactiveDialog}
        onEscKeyDown={toggleInactiveDialog}
      >
        <FormTitle title='Email'>
          <Input
            hint='Enter email ...'
            value={email}
            onChange={onEmailChange}
            type='email'
          />
        </FormTitle>
        <FormTitle title='Name'>
          <Input
            hint='Enter name ...'
            value={name}
            onChange={onNameChange}
          />
        </FormTitle>
      </Dialog>
    )
  }
}

const withConnect = connect(mapStateToProps, mapDispatchToProps)
const withSagas = injectSagas({ [MODULE_NAME]: sagas })

export default compose(
  withSagas,
  withConnect,
)(ClientDialog)
